import React from 'react';

import { DroppableColumn } from './DroppableColumn.jsx';

class GroupedColumns extends React.Component {
  render() {
    return (
      <React.Fragment>
        {this.props.columns.map((column, index) => {
          const columnTiles = this.props.getTiles(column.id);

          return (
            <DroppableColumn
              {...this.props}
              columnId={column.id}
              key={index}
              tiles={columnTiles}
            />
          );
        })}
      </React.Fragment>
    );
  }
}

export default GroupedColumns;
